import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { openNativeAppSettings } from 'shared/utils';

type EnableNotificationsDialogProps = {
  open: boolean;
  onSetOpen: (open: boolean) => void;
};

export const EnableNotificationsDialog = (
  props: EnableNotificationsDialogProps,
): JSX.Element => {
  const { open, onSetOpen } = props;
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={() => onSetOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      slotProps={{
        paper: { sx: { m: 3 } },
      }}
    >
      <DialogTitle
        id="alert-dialog-title"
        sx={{ p: 2, fontWeight: 'fontWeightBold' }}
        variant="body1"
      >
        {t('geoEvent.notifications.notificationsDisabled')}
      </DialogTitle>
      <DialogContent sx={{ p: 2, pb: 0 }}>
        <DialogContentText id="alert-dialog-description">
          {t('geoEvent.notifications.notificationsDisabledText')}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 2, flexDirection: 'column', gap: 2 }}>
        <Button
          onClick={openNativeAppSettings}
          color="primary"
          size="large"
          fullWidth
          autoFocus
        >
          {t('geoEvent.notifications.enableNotifications')}
        </Button>
        <Button
          onClick={() => onSetOpen(false)}
          color="inherit"
          size="large"
          fullWidth
        >
          {t('common.cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
